import SearchTerm from "./SearchTerm";
import React from "react";

const SearchTermsContainer = (props) => {
  const { searchTerms, onRemove, isExtended } = props;
  // console.log("SEARCHTERMS: ", searchTerms);
  return (
    <React.Fragment>
      {searchTerms?.map((searchTerm, index) => (
        <SearchTerm
          editable={props.editable}
          key={index}
          isExtended={isExtended}
          onRemove={() => onRemove(index, isExtended)}
          searchTermId={index}
          searchTerm={searchTerm}
          alternateCall
        />
      ))}
    </React.Fragment>
  );
};

export default SearchTermsContainer;
